import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../../services/ApiService';
import { resolvePublicFileUrl } from '../../utils/imageUrls';

type PublicIdentity = { username?: string; first_name?: string; last_name?: string; bio?: string; avatar_url?: string; state_province?: string; country?: string; instagram_username?: string; website_url?: string };
export default function HomePublicProfile({ username }: { username?: string }) {
  const [profile, setProfile] = useState<PublicIdentity | null>(null);
  useEffect(() => {
    let active = true;
    setProfile(null);
    void (async () => {
      try { const data = await apiService.getUserProfile(); if (active) setProfile(data); } catch { /* Identity link remains usable while profile is unavailable. */ }
    })();
    return () => { active = false; };
  }, [username]);
  if (!username) return null;
  const name = [profile?.first_name, profile?.last_name].filter(Boolean).join(' ') || username;
  return <section aria-label="Your public profile" className="mb-8 flex min-w-0 items-start gap-4 border-b border-white/10 pb-6">
    {profile?.avatar_url && <img src={resolvePublicFileUrl(profile.avatar_url) || undefined} alt="" className="h-16 w-16 shrink-0 rounded-full object-cover" />}
    <div className="min-w-0 flex-1">
      <Link to={`/${encodeURIComponent(username)}`} className="text-xl font-display font-semibold text-white break-words">{name}</Link>
      <p className="text-sm text-orange-400 break-words">@{username}</p>
      {profile?.bio && <p className="mt-2 max-w-prose whitespace-pre-wrap break-words text-sm text-gray-300">{profile.bio}</p>}
      <p className="mt-2 text-xs text-gray-400">{[profile?.state_province, profile?.country].filter(Boolean).join(', ')}</p>
      <Link to={`/${encodeURIComponent(username)}`} className="mt-2 inline-flex min-h-[44px] items-center text-sm text-orange-400">View public profile ↗</Link>
    </div>
  </section>;
}
